import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import CustomSelect, { ICustomSelectProps } from "./common/CustomSelect";
import CustomTextField, {
  ICustomTextFieldProps,
} from "./common/CustomTextField";
import CustomSwitch, { CustomSwitchProps } from "./common/CustomSwitch";

type ImportFormProps = {
  textFields?: (ICustomTextFieldProps & { sx?: SxProps<Theme> })[];
  dropdowns?: (ICustomSelectProps & { sx?: SxProps<Theme> })[];
  switches?: (CustomSwitchProps & { sx?: SxProps<Theme> })[];
  buttons?: React.ReactNode[];
  additionalComponents?: React.ReactNode[];
  sx?: SxProps<Theme>;
  gap?: number | string;
  layout?: "row" | "column";
  flexBasis?: {
    textField?: string;
    dropdown?: string;
    switch?: string;
  };
};

const ImportForm: React.FC<ImportFormProps> = ({
  textFields = [],
  dropdowns = [],
  switches = [],
  buttons = [],
  additionalComponents = [],
  sx,
  gap = 3,
  layout = "row",
  flexBasis = {
    textField: "45%",
    dropdown: "45%",
    switch: "45%",
  },
}) => {
  return (
    <Box
      display="flex"
      flexDirection={layout === "row" ? "row" : "column"}
      flexWrap={layout === "row" ? "wrap" : "nowrap"}
      gap={gap}
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        padding: 2,
        ...sx,
        alignItems: layout === "row" ? "flex-start" : undefined,
      }}
    >
      {textFields.map((field, index) => (
        <Box
          key={`textfield-${index}`}
          sx={{
            flexBasis: layout === "row" ? flexBasis.textField : "100%",
            flexGrow: 1,
            ...field.sx,
          }}
        >
          <CustomTextField {...field} />
        </Box>
      ))}

      {dropdowns.map((dropdownProps, index) => (
        <Box
          key={`dropdown-${index}`}
          sx={{
            flexBasis: layout === "row" ? flexBasis.dropdown : "100%",
            flexGrow: 1,
            ...dropdownProps.sx,
          }}
        >
          <CustomSelect {...dropdownProps} />
        </Box>
      ))}

      {switches.map((switchProps, index) => (
        <Box
          key={`switch-${index}`}
          sx={{
            flexBasis: "100%",
            flexGrow: 1,
            ...switchProps.sx,
          }}
        >
          <CustomSwitch {...switchProps} />
        </Box>
      ))}

      {additionalComponents.map((component, index) => (
        <Box
          key={`component-${index}`}
          sx={{
            flexBasis: "100%",
          }}
        >
          {component}
        </Box>
      ))}

      <Box
        display="flex"
        justifyContent="flex-end"
        gap={2}
        sx={{
          marginTop: layout === "column" ? 2 : 0,
          flexBasis: "100%",
        }}
      >
        {buttons.map((button, index) => (
          <Box key={`button-${index}`}>{button}</Box>
        ))}
      </Box>
    </Box>
  );
};

export default ImportForm;
